export enum ExecutorViewTypes {
  UnitsOwned = 'units-owned',
  UnitsCoOwned = 'units-co-owned',
  Employees = 'employees',
}

export type ExecutorViewType = typeof ExecutorViewTypes[keyof typeof ExecutorViewTypes];
